// src/utils/getProductImagePath.ts

import { PRODUCT_IMAGE_MAP } from '@/constants/productImageMap';
export const getProductImagePath = (productId: number): string => {
  const fileName = PRODUCT_IMAGE_MAP[productId];
  return fileName ? `/images/products/${fileName}` : '/images/products/default.png';
};